import {
  buildBasePath,
  useBaseRouteValue,
} from '../Features/Routing/Utils/routerUtils';
import Logger from '../Utils/Logger';

export const useFrontendUrl = (): string => {
  const baseRouteValues = useBaseRouteValue();
  const baseUrl = window.location.href.match(new RegExp('^(.*?#)'));
  if (!baseUrl) {
    Logger.error(
      'window.location.href har inte en förväntad brädgård(#) notation'
    );
    return '';
  }

  return `${baseUrl[0]}${buildBasePath(baseRouteValues)}`;
};
